import { extendTailwindMerge } from 'tailwind-merge';
import type { ClassNameValue } from 'tailwind-merge';
import { Z_NAMED_LAYERS } from 'src/config/zLayers';
import { DURATIONS, DELAYS } from 'src/config/motion';

export type { ClassNameValue };

export const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      z: [{ z: Object.keys(Z_NAMED_LAYERS) }],
      duration: [{ duration: Object.keys(DURATIONS) }],
      delay: [{ delay: Object.keys(DELAYS) }],
    },
  },
});
